(function (angular, app) {
    "use strict";

    // Heading
    angular.module(app.modules.view.name)
       .directive(app.modules.view.directives.mbwa, mbwaDirective)


    mbwaDirective.$inject = ["$window", "$q", "$timeout", "$interval", "$routeParams", "$sce",
         "$http", "ngDialog"
         , app.modules.common.constants.appsettings
        , app.modules.common.services.functions
        , app.modules.common.services.storage
        , app.modules.invitation.services.invite
        , app.modules.group.services.groups
        , app.modules.outing.services.outings
        , app.modules.scoring.services.score
        , app.modules.handicap.services.handicaps
        , app.modules.ui.services.alerts
        , app.modules.ui.services.ui
        , app.modules.member.services.search
    ];


    function mbwaDirective($window, $q, $timeout, $interval, $routeParams, $sce, $http, ngDialog
        , ggSettings
       , ggFunctions
       , ggStorage
       , ggInvitations
       , ggGroupSvc
       , ggOutingSvc
       , ggScoringSvc
       , ggHandicapSvc
       , ggAlertSvc
       , ggUISvc

       , ggMemberSearchSvc
       ) {
        return {
            restrict: "E"
           , templateUrl: "app/view/directives/mbwa.html"
           , link: function ($scope, element, attrs) {


               var interval;
               $scope.$on('$destroy', function () {
                   // Kill the interval timer
                   if (angular.isDefined(interval)) {
                       $interval.cancel(interval);
                       interval = undefined;
                   }
               });

               $scope.PopupAlert = new ggAlertSvc.popup;

               $scope.window = ggFunctions.fetchWindowSize();
               $scope.external = {
                   url: null
               }
               

               // Epoch time of Start of MBWA
               var startTime = 1503925200;
               var d1 = new Date(0); // The 0 there is the key, which sets the date to the epoch
               d1.setUTCSeconds(startTime);


               
               function formatTimeLength(seconds) {
                   var len = "";
                   var sec = 0;
                   var min = 0;
                   var hr = 0;
                   var day = 0;

                   var obj = {
                       days: "00"
                       , hours: "00"
                       , minutes: "00"
                       , seconds: "00"
                   }

                   seconds = seconds || 0;
                   if (seconds > 0) {
                       var minutes = seconds / 60.00;
                       min = Math.floor(minutes);
                       sec = seconds - (min * 60);

                       if (min < 10) {
                           min = '0' + min;
                       } else {
                           if (min > 59) {
                               var hours = min / 60;
                               hr = Math.floor(hours);
                               min = min - (hr * 60);

                               if (hr < 10) {
                                   hr = '0' + hr;
                               } else {
                                   if (hr > 24) {
                                       var days = hr / 24;
                                       day = Math.floor(days);
                                       hr = hr - (day * 24);
                                   }
                                   if (day < 10) {
                                       day = '0' + day;
                                   }
                               }
                           }
                       }
                       if (sec < 10) {
                           sec = '0' + sec;
                       }

                       obj.days = day;
                       obj.hours = hr;
                       obj.minutes = min;
                       obj.seconds = sec;

                   }
                   return obj;
               }
               

               interval = $interval(function () {
                   // My current epoch time:
                   var d2 = new Date();
                   var seconds = Math.round(d2.getTime() / 1000);

                   // Seconds Left Until Start
                   var remainder = Math.round(d1.getTime() / 1000) - Math.round(d2.getTime() / 1000);
                   if (remainder > 0) {
                       $scope.Temp.countDown = formatTimeLength(remainder);
                   } else{
                       $scope.Temp.countDown = null;
                   }

               }, 1000);

               var ctrl = this;

               // In app purchase
               var inIOSPurchase = {};

               $scope.Temp = {
                   isLoaded: false
                  , isWelcome: false
                  , isSwiper: false
                  , loadCalendar: false
                  , isJumboExpanded: false
                  , member: {
                      name: ""
                     , region: ""
                     , city: ""
                  }
                  , upgrade: {
                      isOnline: false
                     , isRequired: false
                     , isAvailable: false
                     , isSearch: false
                     , isIOSPurchase: 1
                     , isIOS: false
                     , reason: ""
                     , club: {}
                  }
                   , profile: {
                       isUpdate: false
                       , name: false
                       , email: false
                       , phone: false
                       , address: false
                   }
                   , countDown : null
               }


               $scope.Content = {
                   init: function () {
                       if (!$scope.Temp.isLoaded) {

                           // Member Image
                           $scope.Temp.member.image = app.Branding.logoSq;

                           if (app.Member.Detail["photo@odata.mediaReadLink"] && app.Member.Detail["photo@odata.mediaReadLink"] != "") {
                               $scope.Temp.member.image = app.Member.Detail["photo@odata.mediaReadLink"];
                           }

                           ggFunctions.scrollToTop(0);

                           /*
                           var _clubs = function () {
                               return $scope.Content.clubs.fetch();
                           }
                           var _revision = function () {
                               return $scope.Content.handicap.revision.fetch();
                           }
                           var _inprogress = function () {
                               return $scope.Content.scoring.inProgress.fetch()
                           }
       
                           
                           _clubs().then(function () {
                               return _revision();
                           }).then(function () {
                               return _inprogress();
                           }).finally(function () {
                               $scope.Temp.isLoaded = true;
                           });
                           */

                           // Validate Profile information

                           // Mobile Phone
                           if (app.Member.Detail.mobilePhone && app.Member.Detail.mobilePhone != "") {
                               if (isNaN(app.Member.Detail.mobilePhone)) {
                                   $scope.Temp.profile.isUpdate = true;
                                   $scope.Temp.profile.phone = true;
                               }
                           }

                           // EmailAddress
                           if (!app.Member.Detail.email || (app.Member.Detail.email && !ggFunctions.isEmailValid(app.Member.Detail.email))) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.email = true;
                           }

                           // FirstName // LastName
                           if (!app.Member.Detail.firstName || (app.Member.Detail.firstName && app.Member.Detail.firstName == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.name = true;
                           }
                           if (!app.Member.Detail.lastName || (app.Member.Detail.firstName && app.Member.Detail.lastName == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.name = true;
                           }

                           // address -- At least City, PostalCode
                           if (!app.Member.Detail.address.postalCode || (app.Member.Detail.address.postalCode && app.Member.Detail.address.postalCode == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.region || (app.Member.Detail.address.region && app.Member.Detail.address.region == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.city || (app.Member.Detail.address.city && app.Member.Detail.address.city == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.line1 || (app.Member.Detail.address.line1 && app.Member.Detail.address.line1 == "")) {
                               //$scope.Temp.profile.isUpdate = true;
                               //$scope.Temp.profile.address = true;
                           }

                           $scope.Content.outings.playerOrOrganizer.fetch();
                           $scope.Temp.isLoaded = true;
                       }
                   }

                  , outings: {
                     playerOrOrganizer: {
                         results: []
                         , filter: ""
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {
                                
                                $scope.Content.outings.playerOrOrganizer.isLoaded = true;
                                if (results.length > 3) {
                                    $scope.Content.outings.playerOrOrganizer.results = [results[0], results[1], results[2], ]
                                } else {
                                    $scope.Content.outings.playerOrOrganizer.results = results;
                                }
                                return $q.when();
                            };

                            return app.Member.Network.Data.Outings.playerOrOrganizer.fetch(true).then(function (data) {
                                return processData(data);
                            });

                        }
                     }
                     , select: function (outingId) {
                         ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId=" + outingId);
                     }
                  }
                  , news: {
                      isLoaded: false
                      , results : []
                      , fetch: function () {
                          // RSS Feed: http://myrtlebeachworldamateur.com/feed/
                          $http.jsonp("https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20xml%20where%20url%20%3D%20%27http://myrtlebeachworldamateur.com/feed/%27&format=json&callback=JSON_CALLBACK", true).then(function (data, status, headers, config) {
                              console.dir(data);  // XML document object
                              $scope.Content.news.results = data.data.query.results.rss.channel.item;
                          }, function (data, status, headers, config) {
                              console.log("error")
                          });
                      }
                      , trust: function (html) {
                          return $sce.trustAsHtml(html);
                      }
                  }
               }

               $scope.Content.news.fetch();

               // View Functions
               $scope.f = {
                  profilePicture: function () {
                      ggFunctions.goToPage(app.modules.member.routes.profile.path + "?pic")
                  }
                   , updateProfile: function () {
                       ggFunctions.goToPage(app.modules.member.routes.profile.path + "?dirty");
                   }
                  , toggleJumboContent: function () {
                      $scope.Temp.isJumboExpanded = !$scope.Temp.isJumboExpanded;
                  }
                  , formatDateString: function (d) {
                      return ggFunctions.formatDateString(d, "m/d/yyyy", null)
                  }
                  , openUrl : function (url) {
                      $scope.external.url = url + "&gnAppWidth="+$scope.window.modal.wide;
                    app.Member.Session.pageTemplates.fetch(app.modules.view.templates.external).then(function (template) {

                       var _externalModal = ngDialog.open({
                           template: template
                          , plain: true
                          , closeByEscape: true
                          , closeByDocument: true
                          , showClose: true
                          , className: "external"
                          , scope: $scope
                       });
                   });

               }

               }

               


               // Page Request Startup
               if ($routeParams) {
                   // delay initial pop
                   if (app.Member.Auth.isAuthenticated) {
                       $timeout(function () {

                           $scope.Temp.member.name = app.Member.Detail.firstName + " " + app.Member.Detail.lastName;
                           if (($scope.Temp.member.name).trim() == "") {
                               $scope.Temp.member.name = "Hi!";
                               $scope.Temp.member.city = "Welcome to Myrtle Beach World Am."
                           } else {
                               if (app.Member.Detail.address && app.Member.Detail.address.city) {
                                   $scope.Temp.member.city = app.Member.Detail.address.city;
                               }
                               if (app.Member.Detail.address && app.Member.Detail.address.region) {
                                   $scope.Temp.member.region = app.Member.Detail.address.region;
                               }
                           }

                           $scope.Content.init();

                       }, 150);

                   } else {
                       ggFunctions.goToPage(app.modules.view.routes.intro.path);
                   }
               }



           }
        }
    }


}(angular, app));
